import { useEffect, useRef } from "react";

import type { RefObject } from "react";

const useOutsideClick = (
  callback: (eventTarget: HTMLElement | null) => void,
): RefObject<HTMLDivElement | null> => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        if (event.target instanceof HTMLElement) callback(event.target);
        else callback(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callback]);

  return ref;
};

export default useOutsideClick;
